<template>
  <div>
    <permission-not-allowed-modal v-if="shouldShowNotAllowedModal"></permission-not-allowed-modal>
    <upgrade-free-trial v-if="!current_plan_active"></upgrade-free-trial>
    <onboarding v-if="this.shouldShowOnboarding"></onboarding>
  </div>
</template>
<script>
import Onboarding from "@/components/layouts/partials/OnBoarding";
import UpgradeFreeTrial from "@/components/helpers/Specific/UpgradeFreeTrial";
import PermissionNotAllowedModal from "@/components/helpers/Specific/PermissionNotAllowedModal";

export default {
  components: {
    Onboarding,
    UpgradeFreeTrial,
    PermissionNotAllowedModal
  },
  computed: {
    shouldShowOnboarding() {
      return !this.$store.getters.getUserIsOnboarded;
    },
    current_plan_active() {
      return this.$store.getters.getCurrentOrganizationPlanActive;
    },
    shouldShowNotAllowedModal() {
      return this.$store.getters.getNotAllowedModalShown;
    }
  }
}
</script>



// WEBPACK FOOTER //
// Modals.vue?58456bb0